const queryKeys = {
  SCHEDULE: 'SCHEDULE',
  PERSONAL_SCHEDULE: 'PERSONAL_SCHEDULE',
  MEMBER: 'MEMBER',
  LECTURE: 'LECTURE',
  RECORDS: 'RECORDS',
  GYM_ADMINS: 'GYM_ADMINS',
  ACCOUNT: 'ACCOUNT'
};

export default queryKeys;
